import React from 'react';
import type { InternalTrackingCode, ProratedRentResult, TrackingCode } from './types';
// Constellation
import { Box, Button, Paragraph, TextButton } from '@zillow/constellation-10';

interface ResultsProps {
  proratedRent: ProratedRentResult;
  reset: () => void;
  itc: InternalTrackingCode;
  t: TrackingCode;
}

const ZRM_URL = 'zillow.com/rental-manager';

function displayCurrency(number: number): string {
  return '$' + parseFloat(number.toFixed(2)).toLocaleString();
}

const Results: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<ResultsProps>>> = (
  props: ResultsProps,
) => {
  const { itc, proratedRent, reset, t } = props;
  const zrmUrlWithTracking = `//${ZRM_URL}?itc=${itc}&t=${t}`;
  return (
    <Box css={{ textAlign: 'center', marginTop: '800' }}>
      <Box css={{ marginBottom: '1200' }}>
        <Paragraph textStyle="body-lg-bold" css={{ marginBottom: '200' }}>
          Prorated rent for the month of {proratedRent.month}
        </Paragraph>
        <Paragraph css={{ textStyle: 'heading-lg', marginBottom: '200' }}>
          {displayCurrency(proratedRent.days * proratedRent.dailyRent)}
        </Paragraph>
        <Paragraph css={{ marginBottom: '200' }}>
          <strong>{proratedRent.days}</strong> days * <strong>{displayCurrency(proratedRent.dailyRent)}</strong> per day
        </Paragraph>
      </Box>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values */}
      <Button tone="brand" emphasis="filled" onClick={reset} css={{ width: '232px', marginBottom: '800' }}>
        Reset
      </Button>
      <Paragraph css={{ fontSize: '20px', marginBottom: '200' }}>
        Want to streamline managing your properties?
      </Paragraph>
      <TextButton css={{ fontSize: '20px' }} asChild>
        <a href={zrmUrlWithTracking}>Explore Zillow Rental Manager</a>
      </TextButton>
    </Box>
  );
};

export default Results;
